export const getFeatureToggle = 'getFeatureToggle';
